export default function emailSubjectAndBodyQueryParams(
  subject?: string,
  body?: string
) {
  const components = [];
  if (subject) {
    components.push(`subject=${encodeURIComponent(subject)}`);
  }
  if (body) {
    components.push(`body=${encodeURIComponent(body)}`);
  }

  if (components.length === 0) {
    return '';
  }
  return '?' + components.join('&');
}
